import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import Chip, {ChipSize} from 'ui-library/chips/Chip';
import {BaseChipList} from 'ui-library/chips/ChipList';

export default function FeatureTableChipList({items}: {items: Array<string>}): JSX.Element {
  return (
    <BaseChipList
      chips={items.map((item) => (
        <Chip className={css(styles.chip)} text={item} size={ChipSize.TABLE_CELL} tooltipTitle={item} />
      ))}
      maxChips={3}
      isVertical={true}
      chipSize={ChipSize.TABLE_CELL}
      showMoreSize={ChipSize.TABLE_CELL}
    />
  );
}

const styles = StyleSheet.create({
  chip: {
    // pad the chip so that the vertical scrollbar appearing doesn't create a horizontal scrollbar too
    maxWidth: '95%',
  },
});
